import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseView, BaseText } from '@/components/base'
import { FixedBottomButton } from '@/components'
import { Check, WarningEllipses } from '@/assets/icons'
import { useTheme } from '@/hooks/useTheme'
import useOffsets from '@/hooks/useOffsets'

export interface SuccessfullyUpdatedTemplateProps {
  message: string
  description?: string
  type?: 'success' | 'danger'
  buttonText?: string
  buttonType?: 'primaryGradient' | 'secondaryGray' | 'primaryGreen'
  doneRoute: string
  navigationMethod?: 'dismiss' | 'replace'
  onNavigation: () => void
}

export const SuccessfullyUpdatedTemplate: React.FC<
  SuccessfullyUpdatedTemplateProps
> = ({
  message,
  description,
  type = 'success',
  buttonText = 'done',
  buttonType = 'secondaryGray',
  onNavigation,
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const offsets = useOffsets()

  const isDanger = type === 'danger'

  return (
    <BaseView
      className="flex-1"
      style={{
        backgroundColor: theme.colors.background.screen,
        paddingTop: offsets.top,
        height: '100vh',
      }}
    >
      {/* Content centered on screen */}
      <BaseView
        className="flex-1 items-center justify-center"
        style={{
          gap: '24px',
          paddingLeft: 12,
          paddingRight: 12,
          paddingBottom: 120, // Отступ для фиксированной кнопки
        }}
      >
        {/* Success/Warning Icon */}
        <BaseView className="items-center">
          {isDanger ? (
            <WarningEllipses
              size={64}
              color={theme.colors.icon?.ellipsis_warning_error || '#EF4444'}
            />
          ) : (
            <Check size={64} />
          )}
        </BaseView>

        {/* Message and Description */}
        <BaseView className="items-center" style={{ gap: '12px' }}>
          <BaseText
            className="text-center font-medium"
            style={{
              fontSize: '24px',
              color: theme.colors.label.default,
            }}
          >
            {message}
          </BaseText>

          {description && (
            <BaseText
              className="text-center"
              fontFamily="semibold"
              style={{
                fontSize: '14px',
                color: theme.colors.label.description,
              }}
            >
              {description}
            </BaseText>
          )}
        </BaseView>
      </BaseView>

      {/* Fixed Bottom Button */}
      <FixedBottomButton
        buttons={{
          label: t(buttonText),
          type: buttonType,
          onPress: onNavigation,
        }}
      />
    </BaseView>
  )
}
